module.exports = __webpack_public_path__ + "static/media/Caliburn_Declaration_of_Restrictions.bed05dae.pdf";